//define volumes to send to web audio gain node for a given tick
const v1 = .3;
const v2 = .5;
const v3 = .7;
const v4 = 1;

interface ITimeSignatureBeatVolumesPerMeasureMap {
  [key: string]: number[];
}

/**
 * Hash map of key signature to array of volumes for hihat notes in a given bar.
 * e.g. the entry "4_4": [v4, v1, v2, v1, v3, v1, v2, v1],
 * should result in 8 hihat notes being played, at the specified volumes.
 */
export const timeSignatureBeatVolumesPerMeasureMap: ITimeSignatureBeatVolumesPerMeasureMap = {
  "2_2": [v4, v1],
  "2_4": [v4, v1],
  "3_2": [v4, v1, v1],
  "3_4": [v4, v1, v1],
  "3_8": [v4, v1, v1],
  "4_2": [v4, v1, v3, v1],
  "4_4": [v4, v1, v3, v1],
  "6_4": [v4, v1, v1, v3, v1, v1],
  "6_8": [v4, v1, v1, v3, v1, v1],
  "9_4": [v4, v1, v1, v3, v1, v1, v3, v1, v1],
  "9_8": [v4, v1, v1, v3, v1, v1, v3, v1, v1],
  "12_8": [v4, v1, v1, v2, v1, v1, v3, v1, v1, v2, v1, v1],
  "12_4": [v4, v1, v1, v2, v1, v1, v3, v1, v1, v2, v1, v1],
};